import { useContext, useState } from "react";
import IReportFilterCriteria from "../../../../../../shared/contracts/IReportFilterCriteria";
import FilterFieldDialogComponent from "../../../report-data/components/report-data-filters-dialog/components/filter-field-dialog/filter-field-dialog.component";
import FiltersComponent from "../../../report-data/components/report-data-filters-dialog/components/filters/filters.component";
import { CreateReportFormContext } from "../../../../../../shared/context/create-report/create-report-context";
import { FILTER_CATEGORIES } from "../../../../../../shared/contracts/TFilterCategory";

interface IProps {
}

function AppliedFiltersComponent({
}: IProps) {
    const [targetFilterItem, setTargetFilterItem] = useState<IReportFilterCriteria | null>(null);
    const [targetFilterIndex, setTargetFilterIndex] = useState<number>(-1);

    const { createReportForm, dispatch } = useContext(CreateReportFormContext)!;

    const [listFilters, setListFilters] = useState<IReportFilterCriteria[]>(createReportForm?.reportSpecification?.filterCriterias);

    const handleDialogCancel = () => {
        setTargetFilterIndex(-1);
        setTargetFilterItem(null);
    }

    const handleAddNewFilterItem = () => {
        setTargetFilterIndex(-1);
        setTargetFilterItem({
            column: '', operator: '', aliasTable: '', description: '', guid: '', value: '', operatorValueId: 0,
            columnDescription: null,
        });
    }

    const handleEditClick = (filterIndex: number, filterItem: IReportFilterCriteria) => {
        setTargetFilterIndex(filterIndex);
        setTargetFilterItem({ ...filterItem });
    }

    const handleDeleteClick = (filterIndex: number, filterItem: IReportFilterCriteria) => {
        const _filters = [...listFilters]
        _filters.splice(filterIndex, 1);
        setListFilters(_filters);
        dispatch({
            type: 'UPDATE_REPORT_SPECIFICATION',
            payload: { filterCriterias: _filters }
        });
    }

    const handleFilterValueChange = (
        filterIndex: number,
        filterValue: string | null
    ) => {
        const _listFilters = [...listFilters];
        const targetFilterItem = {
            ..._listFilters[filterIndex],
            value: filterValue,
        };

        _listFilters[filterIndex] = targetFilterItem;
        setListFilters([..._listFilters]);
        dispatch({
            type: 'UPDATE_REPORT_SPECIFICATION',
            payload: { filterCriterias: [..._listFilters] }
        });
    };

    const handleFilterItemChange = (filterIndex: number, targetFilterItem: IReportFilterCriteria) => {
        if (filterIndex === -1) {
            setListFilters([...listFilters, targetFilterItem]);
            dispatch({
                type: 'UPDATE_REPORT_SPECIFICATION',
                payload: { filterCriterias: [...listFilters, targetFilterItem] }
            });
        } else {
            const _listFilters = [...listFilters];
            _listFilters.splice(filterIndex, 1, targetFilterItem);
            setListFilters([..._listFilters]);
            dispatch({
                type: 'UPDATE_REPORT_SPECIFICATION',
                payload: { filterCriterias: [..._listFilters] }
            });
        }
        // closes the dialog
        handleDialogCancel();
    }

    return (<>
        <FiltersComponent listFilters={listFilters}
            handleAddNewFilterItem={handleAddNewFilterItem}
            handleEditClick={handleEditClick}
            handleDeleteClick={handleDeleteClick}
            onFilterValueChange={handleFilterValueChange}
        />

        {/* Add/Edit Dialog */}
        {targetFilterItem && <FilterFieldDialogComponent
            targetFilterIndex={targetFilterIndex} targetFilterItem={targetFilterItem}
            defaultAvailableColumns={createReportForm.currentAvailableColumns}
            filterCategories={FILTER_CATEGORIES}
            onApply={handleFilterItemChange} onCancel={handleDialogCancel} />
        }
    </>);
}
export default AppliedFiltersComponent;